export default "__VITE_ASSET__47e899d1__"